export default __webpack_public_path__ + "static/media/GalanoGrotesque-Bold.ea9643bf.ttf";